// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-comments/disallowComments */

export const Colors = {
    // BRAND
    primary: '#002F4D',
    primaryDarkened: '#001C2E',
    primaryMuted: '#335971', // lighter navy for receded/inactive navy surfaces

    secondary: '#00A68D',
    secondarySoft: '#E8F6F4',
    secondaryMuted: '#A1DBD3', // muted turquoise for softer secondary surfaces

    accent: '#ED6A5A',
    accentSoft: '#FAF0ED',

    // SEMATIC COLORS USE ONLY WHEN THE CONTEXT REQUIRES IT, NOT AN ACCENT COLOR

    // SUCCESS
    success: '#2E8B57',
    successBackground: '#E7F4EC',

    // WARNING or ATTENTION
    warning: '#C2492C',
    warningBackground: '#FFF9F1',

    // ERROR or DANGER
    error: '#C3001D',
    errorBackground: '#FADFE2',

    // NEUTRALS
    white: '#ffffff',

    surface: '#f9fafb', // page / subtle background behind white cards

    fill: '#eef0f1', // neutral fill for panels / columns / rows / inputs / disabled states

    border: '#dee0e2', // dividers and borders — darker than the fills so it stays visible

    textSecondary: '#6b6e71', // the one secondary-text color, both products
} as const;

/** Name of a key on the `Colors` palette (e.g. `"primary"`). */
export type ColorToken = keyof typeof Colors;

/** A CSS color string taken from the palette (a value of `Colors`). */
export type ColorsType = (typeof Colors)[ColorToken];
